import React, { createContext, useState } from 'react';

export const ProjectContext = createContext();

export const ProjectProvider = ({children}) => {
    const [text, setText] = useState([]);

    return (
        <ProjectContext.Provider value={{ text, setText }}>
            {children}
        </ProjectContext.Provider>
    )

}